import { Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DataTable, SelectItem } from 'primeng/primeng';

import { Carrier } from '../../models/carrier.model';
import { DepositSearch } from '../../models/depositSearch.model';

import { Router } from '@angular/router';
import { DepositSearchResult } from '../../models/depositSearchResult.model';
import { AuthorizationService } from '../../services/authorization.service';
import { CarrierService } from '../../services/carrier-api.service';
import { DepositService } from '../../services/deposit-api.service';
import { GlobalFilterService } from '../../services/global-filter.service';
import { DepositSearchTableHelper } from './deposit-search.tableHelper';
import { UnapprovedRemittancesComponent } from './unapproved-remittances/unapproved-remittances.component';
import { CreateZeroDollarCheckComponent } from './create-zerodollar-check/create-zerodollar-check.component';
import { ZeroDollarCheckDeposit } from '../../models/zerodollarcheckdeposit.model';


const REMITTANCE_ENTRY_ROUTE = 'remittanceentry';
const CREATE_ZERODOLLAR_CHECK_ERROR = 'An error occurred while creating a $0 Check.  If this problem continues please contact your account team.';

@Component({
  selector: 'app-deposit-search',
  templateUrl: './deposit-search.component.html',
  styleUrls: ['./deposit-search.component.css'],
})

export class DepositSearchComponent implements OnInit {
  yearRange = `1970:${new Date().getFullYear()}`;
  searchLoading: boolean;
  depositSearchForm: FormGroup;
  depositSearch: DepositSearch;
  @ViewChild('checkNumberInput') checkNumberInputField: ElementRef;
  @ViewChild('unapprovedRemittances') unapprovedRemittances: UnapprovedRemittancesComponent;
  @ViewChild('createZeroDollarCheck') createZeroDollarCheck: CreateZeroDollarCheckComponent;

  carrierSelections: SelectItem[] = [];
  carrierListLoading: boolean;

  deposits: DepositSearchResult[];
  readonly tableHelper: DepositSearchTableHelper;

  readonly rowLimit: number = 15;
  totalItemCount: number;
  offset: number;
  sortField = 'Check_CheckNumber';
  sortOrder: number;
  showApprovalTable: boolean = false;

  zeroDollarCheckDeposit: ZeroDollarCheckDeposit;
  displayZeroDollarCheckModal: boolean = false;
  zeroDollarCarrierSelections: SelectItem[];
  zeroDollarCarrierId: string;
  zeroDollarCheckNumber: string;
  zeroDollarDepositDate: string;
  zeroDollarCheckProcessing: boolean = false;

  constructor(
    private authorizationService: AuthorizationService,
    private globalFilterService: GlobalFilterService,
    // private route: ActivatedRoute,
    private router: Router,
    // private params: ParamMap,
    private carrierService: CarrierService,
    private depositService: DepositService,
    private fb: FormBuilder,
    ) {
      this.tableHelper = new DepositSearchTableHelper();
      this.initFormData();
  }

  initFormData(): void {
    this.depositSearchForm = this.fb.group({
      carrierControl: this.fb.control(null),
      checkNumber: this.fb.control(null),
      checkAmount: this.fb.control(null),
      depositDate: this.fb.control(null),
    });
  }

  ngOnInit(): void {
    this.checkNumberInputField.nativeElement.focus();
    //this.depositSearchFocusElement = this.checkNumberInputField;
    this.buildCarrierDropList();
    this.callNotifyService();
    // Check if supervisor approval table should be shown
    if (this.authorizationService.hasFeature("UI::MREOverride")) {
      this.showApprovalTable = true;
    }
    this.zeroDollarCarrierSelections = this.carrierSelections;
    this.zeroDollarCheckDeposit = new ZeroDollarCheckDeposit(
      null,
      null,
      null);

    this.depositSearchForm.valueChanges.subscribe(selectedValue => {
      this.zeroDollarCarrierId = this.depositSearchForm.get("carrierControl").value;
      this.zeroDollarCheckNumber = this.depositSearchForm.get("checkNumber").value;
      this.zeroDollarDepositDate = this.depositSearchForm.get("depositDate").value;
    });
      
  }

  async buildCarrierDropList() {
    this.carrierListLoading = true;

    await this.carrierService.GetCarriersOfClient(this.globalFilterService.selectedEnvironment.ClientId4Digit)
      .then((carriers) => {
        if (carriers.TotalItemCount === 0) {
          toastr.error('No Carriers were found.  If this problem continues please contact your account team.');
          return;
        }
        carriers.Items.forEach((carrier: Carrier) => {
          let labelName = `${carrier.CarrierId} - ${carrier.CarrierName}`;
          let carrierSelection = {
            label: labelName,
            value: carrier.CarrierId,
          }
          this.carrierSelections.push(carrierSelection)
        })
        this.carrierListLoading = false;
      })
      .catch( () => {
        toastr.error('An error occurred while creating a $0 Check.  If this problem continues please contact your account team.');
      });
  }

  searchClick() {
    this.depositSearch = {
      Payer_ShardPayerIdentifier: this.depositSearchForm.controls['carrierControl'].value,
      Check_CheckNumber: this.depositSearchForm.controls['checkNumber'].value,
      Check_CheckAmount: this.depositSearchForm.controls['checkAmount'].value,
      Deposit_DepositDate: this.depositSearchForm.controls['depositDate'].value,
    }

    this.offset = 0;
    this.totalItemCount = 0;
    this.loadData();
  }

  zeroDollarDepositClick() {
    this.zeroDollarCarrierId = (this.depositSearchForm.controls['carrierControl'].value) ? this.depositSearchForm.controls['carrierControl'].value : null;
    this.zeroDollarCheckNumber = (this.depositSearchForm.controls['checkNumber'].value) ? this.depositSearchForm.controls['checkNumber'].value : null;
    this.zeroDollarDepositDate = (this.depositSearchForm.controls['depositDate'].value) ? this.depositSearchForm.controls['depositDate'].value : null;
    this.displayZeroDollarCheckModal = true;
  }

  SetZeroDollarCarrier() {
    this.zeroDollarCarrierId = (this.depositSearchForm.controls['carrierControl'].value) ? this.depositSearchForm.controls['carrierControl'].value : null;
  }

  async onCancelZeroDollarCheckApply(event: boolean) {
    this.displayZeroDollarCheckModal = false;
    this.sortField = 'Check_CheckNumber';
    this.sortOrder = 1;
    this.deposits = [];
    this.totalItemCount = 0;
    this.initFormData();

    this.checkNumberInputField.nativeElement.focus();
  }

  async onCreateZeroDollarCheckApply(event: ZeroDollarCheckDeposit) {
    this.zeroDollarCheckDeposit = event as ZeroDollarCheckDeposit;
    
    if(Date.parse(this.zeroDollarCheckDeposit.Deposit_DepositDate.getTime().toString()) > Date.now()) {          
      toastr.error('An error occurred while creating a $0 Check.  Deposit Date must not be a future date.');
    }
    else{
      await this.depositService.createZeroDollarCheck(
        this.globalFilterService.selectedEnvironment.ClientId4Digit, 
        this.zeroDollarCheckDeposit)
        .then((data) =>  {
          toastr.success('$0 Check Created');
          this.depositSearch = data; 
          this.router.navigate([REMITTANCE_ENTRY_ROUTE, data]);
        })
        .catch( () => {
          toastr.error(CREATE_ZERODOLLAR_CHECK_ERROR);
          this.searchLoading = false;
        }
      );
    }
  }

  paginate(event) {
    this.offset = event.first;
    this.loadData();
  }

  sort(event) {
    this.sortField = event.field;
    this.sortOrder = event.order;
    this.offset = 0
    this.loadData();
  }

  onRowSelect(event): void {
    this.router.navigate([REMITTANCE_ENTRY_ROUTE, event.data])
  }

  loadData() {
    this.callNotifyService();
    this.searchLoading = true;

    this.depositService.searchDeposits<DepositSearchResult>(this.globalFilterService.selectedEnvironment.ClientId4Digit,
        this.depositSearch,
        this.rowLimit,
        this.offset,
        this.sortField,
        this.sortOrder)
      .then((data) =>  {
        this.deposits = data.Items;
        this.totalItemCount = data.TotalItemCount;
        this.searchLoading = false;

        if (this.totalItemCount === 1) {
          this.handleSingleItemReturned(this.deposits[0]);
        }
      })
      .catch( () => {
        toastr.error('An error occurred while executing your search criteria.   If this problem continues please contact your account team.');
        this.searchLoading = false;
      });
  }

  handleSingleItemReturned(resultItem: DepositSearchResult) {
    this.router.navigate([REMITTANCE_ENTRY_ROUTE, resultItem])
  }

  resetClick(dtDeposits: DataTable) {
    dtDeposits.reset();
    this.sortField = 'Check_CheckNumber';
    this.sortOrder = 1;
    this.deposits = [];
    this.totalItemCount = 0;
    this.initFormData();
    this.checkNumberInputField.nativeElement.focus();
  }

  private callNotifyService() {
    if (!this.authorizationService.HealthcareTopBar || !this.authorizationService.HealthcareTopBar.notifyActivity) {
      return;
    }
    this.authorizationService.HealthcareTopBar.notifyActivity();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/deposit-search/deposit-search.component.ts